import { toI18n } from 'util/i18n';
export const HIRING_V2_SLICE_NAME = 'hiringV2';

export const HIRING_V2_BASE_URL = '/hiring/v2';
export const HIRING_V2_URLS = {
  DASHBOARD: `${HIRING_V2_BASE_URL}/dashboard`,
  JOB_POST: (id: string) => `${HIRING_V2_BASE_URL}/job_posts?id=${id}`,
  JOB_POSTS: `${HIRING_V2_BASE_URL}/job_posts`,
  JOB_REQUESTS: `${HIRING_V2_BASE_URL}/job_requests`,
  NEW_JOB_REQUESTS: `${HIRING_V2_BASE_URL}/job_requests/new`,
  REVIEW_APPLICANTS: `${HIRING_V2_BASE_URL}/review_applicants`,
  CANDIDATE_PROFILE: (id: string) =>
    `${HIRING_V2_BASE_URL}/review_applicants?profile=true&candidate_id=${id}`,
  SCREENING_AGENT_DEMO: `${HIRING_V2_BASE_URL}/screening_agent_demo`,
  SET_INTERVIEW_TIMES: `${HIRING_V2_BASE_URL}/set_interview_times`,
};

export const JOB_REQUEST_STATUS = {
  ACTIVE: 'active',
  DRAFT: 'draft',
  PENDING_REVIEW: 'pending_review',
  FLAGGED: 'flagged',
  CLOSED: 'closed',
  ARCHIVED: 'archived',
  EXPIRED: 'expired',
} as const;

export enum AGG_JOB_REQUEST_STATUS {
  LIVE = 'live',
  DRAFT = 'draft',
  IN_REVIEW = 'in_review',
  CLOSED = 'closed',
}

export enum INTERVIEW_STATUS {
  CONFIRMED = 'accepted',
  NOT_CONFIRMED = 'pending',
  NEW_TIME_PROPOSED = 'reschedule_requested',
}

export const DAY_NUMBER_MAPPING: Record<string, string> = {
  0: toI18n('hiring.v2.job_request.job_description_page.job_details.monday'),
  1: toI18n('hiring.v2.job_request.job_description_page.job_details.tuesday'),
  2: toI18n('hiring.v2.job_request.job_description_page.job_details.wednesday'),
  3: toI18n('hiring.v2.job_request.job_description_page.job_details.thursday'),
  4: toI18n('hiring.v2.job_request.job_description_page.job_details.friday'),
  5: toI18n('hiring.v2.job_request.job_description_page.job_details.saturday'),
  6: toI18n('hiring.v2.job_request.job_description_page.job_details.sunday'),
};

export const DAY_NUMBER_MAPPING_REVERSE: Record<string, string> = {
  monday: '0',
  tuesday: '1',
  wednesday: '2',
  thursday: '3',
  friday: '4',
  saturday: '5',
  sunday: '6',
};

export const DEFAULT_JOB_ROLES = [
  'Server',
  'Cashier',
  'Bartender',
  'Barista',
  'Cook',
];

export const HIRING_V2_ONBOARDING_FAQ_ITEMS = [
  {
    question: 'How much does it cost?',
    answer:
      'The Hiring Assistant is free until September 1, 2025. After that, to screen candidates, ' +
      "parse resumes, find matches, and handle scheduling, it's $150 per posting.",
  },
  {
    question: 'How does the Hiring Assistant screen applicants?',
    answer:
      'The Hiring Assistant will use the screening questions you set up to screen every ' +
      "applicant 24/7. It'll follow up and ask clarifying questions to find a top match.",
  },
  {
    question: 'Will I have say on who I interview?',
    answer:
      'Absolutely! The Hiring Assistant will pre-schedule top matches, but you can decline ' +
      "if it's not a fit.",
  },
  {
    question: "How do I set when I'm available to interview candidates?",
    answer:
      "You'll be able to choose your interview availability times. The Assistant will " +
      'pre-schedule top matches in those time slots. You can change this at any time.',
  },
];

export const HOMEBASE_BACKGROUND_CHECK_URL = '/hr_center/background_checks';

export const HIRING_V2_WAITLIST_LOCAL_STORAGE_KEY = 'HIRING_V2_WAITLIST';
